import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

const baseURI = '/catalogos/personal-de-convenios/';

/**
 * GET Personal de Convenios
 * @returns {Promise<Array<object>>}
 */
export const getPersonalDeConvenios = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * POST Personal de Convenios
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPersonalDeConvenios = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Personal de Convenios
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPersonalDeConvenios = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Personal de Convenios
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deletePersonalDeConvenios = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
